import React from 'react';

import { UseMutationResult } from '@tanstack/react-query';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../constants/aampeTheme';

// Components
import BackButton from '../../buttons/backButton';
import TitleEdit from './titleEdit';

interface TitleBarProps {
    title: React.ReactNode;
    subTitle?: string;
    description?: React.ReactNode;
    isUpdating?: boolean;
    backLink?: string;
    backText?: string;
    onTitleChange?: (value: string) => void;
    allowEmptyTitle?: boolean;
    onTitleChangeMutation?: UseMutationResult<any, any, any, any>;
    titleToolTip?: string;
    isSecondary?: boolean;
    isDisabled?: boolean;
    showInfoIcon?: boolean;
    onInfoIconClick?: () => void;
    showBetaModeBanner?: boolean;
}

const TitleBar: React.FC<React.PropsWithChildren<TitleBarProps>> = ({
    title,
    subTitle,
    description,
    isUpdating,
    backLink,
    backText = 'Back',
    onTitleChange,
    allowEmptyTitle,
    onTitleChangeMutation,
    titleToolTip,
    isSecondary = false,
    isDisabled,
    showInfoIcon,
    onInfoIconClick,
    showBetaModeBanner,
}) => {
    return (
        <Container>
            {backLink && (
                <BackButton destination={backLink} tooltip={backText} />
            )}
            <Section>
                <TitleEdit
                    title={title}
                    isDisabled={isDisabled}
                    onChange={onTitleChange}
                    allowEmptyTitle={allowEmptyTitle}
                    onTitleChangeMutation={onTitleChangeMutation}
                    isUpdating={isUpdating}
                    titleToolTip={titleToolTip}
                    isSecondary={isSecondary}
                    onInfoIconClick={onInfoIconClick}
                    showInfoIcon={showInfoIcon}
                    showBetaModeBanner={showBetaModeBanner}
                />
                {subTitle ? <SubTitle>{subTitle}</SubTitle> : null}
                {description &&
                    (typeof description === 'string' ? (
                        <p>{description}</p>
                    ) : (
                        description
                    ))}
            </Section>
        </Container>
    );
};

const Container = styled.div(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'inherit',
    flex: 1,
}));

const SubTitle = styled.h5(() => ({
    margin: aampeTheme.spacing(0.25, 0),
    padding: aampeTheme.spacing(0),
    color: 'gray',
}));

const Section = styled.div({
    flex: 1,
});

export default TitleBar;
